import styled from 'styled-components';

export const FooterOuterWrap = styled.div(
  props => `
      width:100%;
      height: 25rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background-color: #dff0ff;
      padding: ${props.theme.spacing.large.l20} ${props.theme.spacing.large.l75} ${props.theme.spacing.large.l20} ${props.theme.spacing.large.l60} ;
      border-top: solid 1px #8ebde3;

      @media only screen and (min-width:320px) and (max-width: 767px){
          height: 14rem;
          padding: ${props.theme.spacing.large.l75} ${props.theme.spacing.large.l20} ${props.theme.spacing.large.l20};
      }

      @media only screen and (min-width:768px) and (max-width: 1024px){
          padding: ${props.theme.spacing.large.l20}
      }
      @media only screen and (min-width:1025px) and (max-width: 1300px){
          width: 98%;
          margin: 0 auto;
          padding: ${props.theme.spacing.large.l20} ${props.theme.spacing.nospacing}
      }
  `,
);

export const FooterInnerWrap = styled.div(
  props => `
    max-width: 1200px;
    margin: 0 auto;
    width:100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  `
);

export const CopyRightText = styled.p(
  props => `
    align-self: flex-end;
    display: flex;
    font-size: ${props.theme.font.large.font14};
    color: ${props.theme.colors.black.base};
    @media only screen and (min-width:320px) and (max-width: 767px){
      text-align: center;
      width:100%;
      align-items: center;
      justify-content: center;
    }
  `
)
